function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M19,17.6L17.6,19l-6.4-6.4l1.4-1.4L19,17.6z M11.1,1C8.5,1,6,2,4,3.9l0,0C0,7.9,0,14.3,4,18.3 L18.3,4C16.3,2,13.7,1,11.1,1z M4.1,15.3C3.4,14,3,12.6,3,11.1c0-0.9,0.2-1.8,0.5-2.7c0.2,1.9,0.9,3.8,2.1,5.4L4.1,15.3z M7,12.4 c-1.3-2.1-1.9-4.5-1.4-6.8c0.6-0.1,1.2-0.2,1.8-0.2c1.8,0,3.5,0.5,5.1,1.6L7,12.4z M8.4,3.5C9.3,3.2,10.2,3,11.1,3 c1.5,0,2.9,0.4,4.1,1.1l-1.4,1.4C12.2,4.3,10.4,3.6,8.4,3.5L8.4,3.5z"
});

var SvgMoveOutInsurance = function SvgMoveOutInsurance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoveOutInsurance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move_out_insurance.851c5f96.svg";
export { ForwardRef as ReactComponent };